import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  addMarathonQuestionToList,
  removeMarathonQuestionFromList,
  removeMarathonSingleTicket,
  setMarathonAnswer,
  setMarathonScores,
  setMarathonScoresCurrentPage,
  setMarathonScoresTotalPages,
  setMarathonTicketList,
  setMarathonTicketListCurrentPage,
  setMarathonTicketListTotalPages,
  updateMarathonQuestionInList,
  updateMarathonScoreInList,
} from "../../redux/actions/Tests";
import TestsRequests from "services/tests";

import axios from "../auth/jwt/config";

const MarathonRequests = {
  addMarathonQuestion: (questionData) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          dispatch(fetchStart());
          axios
            .post(`/marathonDanaie/eventQuestion/create`, questionData)
            .then(({ data }) => {
              dispatch(fetchSuccess("با موفقیت اضافه شد"));
              dispatch(addMarathonQuestionToList(data));
              resolve(data);
            })
            .catch((error) => {
              if (error.response) {
                dispatch(
                  fetchError(
                    error.response.data.msgFa || error.response.data.msg
                  )
                );
                reject(error.response.data.msgFa || error.response.data.msg);
              } else {
                dispatch(fetchError(error.message));
                reject(error.message);
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
          reject(error.message);
        }
      });
    };
  },

  updateMarathonQuestion: (id, questionData) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          dispatch(fetchStart());
          axios
            .patch(`/marathonDanaie/eventQuestion/update/${id}`, questionData)
            .then(({ data }) => {
              dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
              dispatch(updateMarathonQuestionInList(id, data));
              resolve(data);
            })
            .catch((error) => {
              if (error.response) {
                dispatch(
                  fetchError(
                    error.response.data.msgFa || error.response.data.msg
                  )
                );
                reject(error.response.data.msgFa || error.response.data.msg);
              } else {
                dispatch(fetchError(error.message));
                reject(error.message);
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
          reject(error.message);
        }
      });
    };
  },

  removeMarathonQuestion: (id) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          dispatch(fetchStart());
          axios
            .delete(`/marathonDanaie/eventQuestion/remove/${id}`)
            .then(() => {
              dispatch(fetchSuccess("با موفقیت حذف شد"));
              dispatch(removeMarathonQuestionFromList(id));
              resolve();
            })
            .catch((error) => {
              if (error.response) {
                dispatch(
                  fetchError(
                    error.response.data.msgFa || error.response.data.msg
                  )
                );
                reject(error.response.data.msgFa || error.response.data.msg);
              } else {
                dispatch(fetchError(error.message));
                reject(error.message);
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
          reject(error.message);
        }
      });
    };
  },

  getMarathonQuestionsByEvent: (eventId) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          dispatch(fetchStart());
          axios
            .get(`/marathonDanaie/eventQuestion/getByEvent/${eventId}`)
            .then(({ data }) => {
              dispatch(fetchSuccess());
              resolve(data);
            })
            .catch((error) => {
              if (error.response) {
                dispatch(
                  fetchError(
                    error.response.data.msgFa || error.response.data.msg
                  )
                );
                reject(error.response.data.msgFa || error.response.data.msg);
              } else {
                dispatch(fetchError(error.message));
                reject(error.message);
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
          reject(error.message);
        }
      });
    };
  },
  addBatchMarathonQuestions: (file, eventId) => {
    return async (dispatch) => {
      const formData = new FormData();
      formData.append("csvFile", file);
      try {
        axios
          .post(
            `/marathonDanaie/eventQuestion/addbatch?eventId=${eventId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(({ data }) => {
            dispatch(
              fetchSuccess(`${data.addedQuestionCount} مورد با موفقیت اضافه شد`)
            );
            TestsRequests.getMarathonQuestionsById(eventId)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError("مشکل در آپلود "));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getMarathonTicketList: (eventId, page, searchStr) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/marathonDanaie/eventTicket/getall/admin/${eventId}?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setMarathonTicketList(data.docs));
            dispatch(setMarathonTicketListCurrentPage(data.page));
            dispatch(setMarathonTicketListTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeMarathonTicketById: (ticketId, totalItems, currentPage, eventId) => {
    return (dispatch) => {
      try {
        axios
          .get(`/marathonDanaie/eventTicket/remove/${ticketId}`)
          .then(() => {
            dispatch(removeMarathonSingleTicket(ticketId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                MarathonRequests.getMarathonTicketList(
                  eventId,
                  currentPage - 1
                )(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  batchRemoveAnswers: (ticketId) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .delete(`/marathonDanaie/eventAnswer/batchRemove/${ticketId}`)
          .then(({ data }) => {
            dispatch(fetchSuccess(data.msgFa || data.msg || "با موفقیت حذف شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa || error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getMarathonAnswer: (eventId, userId) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          dispatch(fetchStart());
          axios
            .get(
              `/marathonDanaie/eventAnswer/getuser?eventId=${eventId}&userId=${userId}`
            )
            .then(({ data }) => {
              dispatch(fetchSuccess());
              dispatch(setMarathonAnswer(data));
              resolve(data);
            })
            .catch((error) => {
              if (error.response) {
                dispatch(
                  fetchError(
                    error.response.data.msgFa || error.response.data.msg
                  )
                );
                reject(error.response.data.msgFa || error.response.data.msg);
              } else {
                dispatch(fetchError(error.message));
                reject(error.message);
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
          reject(error.message);
        }
      });
    };
  },
  getMarathonScores: (page, searchStr) => {  
    return (dispatch) => {
      try {
        axios
          .get(
            `/marathonDanaie/score/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setMarathonScores(data.docs));
            dispatch(setMarathonScoresCurrentPage(data.page));
            dispatch(setMarathonScoresTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateMarathonScore: (id, updatedScore) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/marathonDanaie/score/update/${id}`, updatedScore)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(updateMarathonScoreInList(id, data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default MarathonRequests;
